import { useLocalStorage } from 'hooks/useLocalStorage';
import { Merchandise } from './useProductImporter';

export function useRecentlyViewedProducts() {
  return useLocalStorage<Merchandise[]>('recently_viewed_products', JSON.parse, JSON.stringify);
}
